/** 与 src/assets/styles/_layout.scss 保持一致 */

/** H5 上限（含）：屏幕宽度 < 1000px 走 H5 显示层 */
export const MOBILE_MAX_PX = 999;

/** PC 下限 */
export const DESKTOP_MIN_PX = 1000;

export const MEDIA_MOBILE_MAX = `(max-width: ${MOBILE_MAX_PX}px)`;
export const MEDIA_DESKTOP_MIN = `(min-width: ${DESKTOP_MIN_PX}px)`;
